export default "__VITE_ASSET__Bti0b5Cr__"